export default __webpack_public_path__ + "static/media/beachCleanup.cd594f0c.jpg";